/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tpm_Modal_SubtitleInputs */

const en_tpm_modal_subtitle = /** @type {(inputs: Tpm_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any other problem that doesn't fit the other report types.`)
};

const ja_tpm_modal_subtitle = /** @type {(inputs: Tpm_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の報告タイプに当てはまらない、その他の問題に使用します。`)
};

const fr_tpm_modal_subtitle = /** @type {(inputs: Tpm_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour tout autre problème ne correspondant à aucun autre type de signalement.`)
};

const de_tpm_modal_subtitle = /** @type {(inputs: Tpm_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für alle anderen Probleme, die zu keiner anderen Meldungsart passen.`)
};

/**
* | output |
* | --- |
* | "For any other problem that doesn't fit the other report types." |
*
* @param {Tpm_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const tpm_modal_subtitle = /** @type {((inputs?: Tpm_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tpm_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tpm_modal_subtitle(inputs)
	if (locale === "ja") return ja_tpm_modal_subtitle(inputs)
	if (locale === "fr") return fr_tpm_modal_subtitle(inputs)
	return de_tpm_modal_subtitle(inputs)
});